"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _invariant = _interopRequireDefault(require("react-utils/invariant"));

var segmentize = function segmentize(uri) {
  return uri.replace(/(^\/+|\/+$)/g, '').split('/');
};

var paramRe = /^:(.+)/;

var _default = function _default(routes) {
  var routeSegmentsCache = {};
  routes.forEach(function (route) {
    routeSegmentsCache[route] = segmentize(route);
  });
  return function (route, pathname) {
    var pathnameSegments = segmentize(pathname);
    var routeSegments = routeSegmentsCache[route];
    (0, _invariant.default)(routeSegments, "unexpected route " + route);

    if (pathnameSegments.length !== routeSegments.length) {
      return false;
    }

    var index = 0;

    for (; index < routeSegments.length; index++) {
      var routeSegment = routeSegments[index];
      var pathnameSegment = pathnameSegments[index];

      if (routeSegment !== pathnameSegment && !routeSegment.match(paramRe)) {
        return false;
      }
    }

    return true;
  };
};

exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/react-rhumb/static-1.5065/js/internal/matchRoute.js
// module id = 624
// module chunks = 209 210 211 212